module.exports = __webpack_public_path__ + "img/8_2.8c674e6e.png";